import { FormControlSizes, HStack, IconButton, IconName, IndicatorBadge, Text } from '@talos/kyoko';
import type { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { GROUP_AGGREGATIONS, GROUP_DEFAULT_AGGREGATION } from '../presetListModel';

function PresetListGroupHeaderShell({ headerTestId, children }: { headerTestId: string; children: ReactNode }) {
  return <div data-testid={headerTestId}>{children}</div>;
}

export function PresetListGroupHeader({
  groupTitle,
  itemCount,
  hideAggregationsToolbar,
  onPressSearch,
}: {
  groupTitle: string;
  itemCount?: number;
  hideAggregationsToolbar: boolean;
  onPressSearch: () => void;
}) {
  const theme = useTheme();

  if (groupTitle === GROUP_AGGREGATIONS && hideAggregationsToolbar) {
    return null;
  }

  const headerTestId =
    groupTitle === GROUP_DEFAULT_AGGREGATION
      ? 'market-selector-default-aggregation-group-header'
      : 'market-selector-aggregations-group-header';

  return (
    <PresetListGroupHeaderShell headerTestId={headerTestId}>
      <HStack
        justifyContent="space-between"
        alignItems="center"
        w="100%"
        background="backgroundDropdownGroupHeader"
        py="spacing4"
        px="spacing12"
        fontSize="fontSizeTiny"
        borderBottom={`solid 1px ${theme.backgroundDropdown}`}
      >
        <HStack gap="spacing4" alignItems="center" justifyContent="flex-start">
          <Text size="fontSizeTiny" textTransform="uppercase" color="colorTextSubtle" style={{ fontWeight: 500 }}>
            {groupTitle}
          </Text>
          {groupTitle !== GROUP_DEFAULT_AGGREGATION && itemCount != null ? (
            <IndicatorBadge>{itemCount}</IndicatorBadge>
          ) : null}
        </HStack>
        {groupTitle === GROUP_AGGREGATIONS && !hideAggregationsToolbar && (
          <IconButton icon={IconName.Search} size={FormControlSizes.Tiny} dim onClick={onPressSearch} />
        )}
      </HStack>
    </PresetListGroupHeaderShell>
  );
}
